import styled from "styled-components";
import { CategoryItem } from "app/components/React/CategoriesDropdown/CategoryDropdown";

export const StyledCategoryItem = styled(CategoryItem)`
    font-weight: 400;
`;
